<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="사업안내" tabActive="오시는길" bg="/images/sub/business/visual.jpg">
                <template #title>사업안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>오시는길</template>

            <v-row justify="center">
                <v-col cols="auto">
                    <v-sheet color="primary" class="direction-sheet">
                        <tit class="tit--sm white--text">2호선 건대입구역 6출구, 도보 1분 7호선 건대입구역 2번출구 도보 6분</tit>
                    </v-sheet>
                </v-col>
                <v-col cols="12">
                    <div class="map-wrap">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.60529836091!2d127.06415417642951!3d37.54080052560253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca4ebd5d75ff1%3A0x2c84180925d56ea3!2z7ISc7Jq47Yq567OE7IucIOq0keynhOq1rCDsnpDslpHrj5kgOC04!5e0!3m2!1sko!2skr!4v1730882733017!5m2!1sko!2skr" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="map" />
                    </div>
                    <v-card flat tile color="grey" class="map-card">
                        <div class="map-card__inner">
                            <v-row class="row--sm">
                                <v-col cols="12" md="2"><h3>주소</h3></v-col>
                                <v-col>서울특별시 광진구 자양동 8-8번지 외 3필지(290-12) (2, 7호선 건대입구역 6번 출구)</v-col>
                            </v-row>
                            <v-row class="row--sm">
                                <v-col cols="12" md="2"><h3>전화</h3></v-col>
                                <v-col>02-6239-0330</v-col>
                            </v-row>
                            <v-row class="row--sm">
                                <v-col cols="12" md="2"><h3>이메일</h3></v-col>
                                <v-col>thepodium830@naver.com</v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        Tit,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.direction-sheet {
    text-align: center;
    padding: 12px;
    border-radius: var(--rounded-lg);
}
.map-wrap {
    position: relative;
    height: 300px;
    overflow: hidden;
}
.map {
    display: block;
    width: 100%;
    height: 406px;
    border: none;
    position: absolute;
    left: 0;
    bottom: 0;
}
.map-card {
    font-size: var(--txt-font-size-lg);
    color: #fff;
    padding: 24px 12px;
    width: 100%;
    display: flex;
    align-items: center;
    margin: 20px auto 0;
    background: url("/images/sub/business/direction/map-card.png") no-repeat right;
    background-size: auto 100%;
    &__inner {
        width: 100%;
    }
}
@media (min-width: 768px) {
    .direction-sheet {
        padding: 12px 24px;
        border-radius: 999px;
    }
    .map-wrap {
        height: 400px;
    }
    .map {
        height: 506px;
    }
}
@media (min-width: 1024px) {
    .map-wrap {
        height: 586px;
    }
    .map {
        height: 692px;
    }
    .map-card {
        font-size: 18px;
        height: 194px;
        margin-top: 30px;
        padding: 0 24px;
    }
}
</style>
